<div class="card card-custom h-100">
    <div class="card-header align-items-center border-0">
        <div class="card-title">
            <span class="card-icon">
                <i class="la la-pie-chart text-success"></i>
            </span>
            <h3 class="card-label text-success">
                {{"EditionStatistics" | localize}}
                <small class="text-muted"  *ngIf="editionStatisticsHasData">{{selectedDateRange[0] | luxonFormat: 'D'}}
                    - {{selectedDateRange[1] | luxonFormat: 'D'}}</small>
            </h3>
        </div>
    </div>
    <div class="card-body" [perfectScrollbar]>
        <ngx-charts-pie-chart *ngIf="editionStatisticsHasData" [results]="editionStatisticsData"
                              [legend]="true" [doughnut]="true" [arcWidth]="0.75">
        </ngx-charts-pie-chart>
        <div class="note note-info d-flex flex-column justify-content-center align-items-center chart "[hidden]="editionStatisticsHasData">
           
            <div class="w-160px">
        
                <div class="w-160px">
                    <img src="../../../../assets/common/images/time-off/empty-state-ui/my-time-off-empty-state.svg"
                        class="w-100">
                </div>
            </div>
            <h6 class="text-muted text-center mt-5">{{'NoDataFound' | localize}}</h6>
        </div>
    </div>
</div>
